import { defineComponent as _defineComponent } from 'vue'
import type { PageListItem } from '@/components/nav/static-pages/types';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'PagesList',
  props: {
    pages: { default: () => [] }
  },
  setup(__props: any) {



const router = useRouter();

async function go(path: string, external: boolean) {
	const { popoverController } = await import('@/ionic.loader');

	if (external) {
		window.open(path, '_blank', 'noopener');
	} else {
		router.push({ path });
	}

	popoverController.dismiss();
}

return { __sfc: true,router, go }
}

})